"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnchorP2PFieldView = exports.AnchorManualFieldView = void 0;
exports.viewAnchorManualEdit = viewAnchorManualEdit;
const core_shared_1 = require("@ikegps/core-shared");
const lodash_1 = require("lodash");
const anchor_input_1 = require("../../../components/input/anchor.input");
const anchor_input_state_1 = require("../../../components/input/anchor.input.state");
const i18n_1 = require("../../../i18n");
const field_info_1 = require("../../field.info/field.info");
const point_collection_cache_1 = require("../../topological.editor.map/point.collection.cache");
function viewAnchorManualEdit(field, ctrl) {
    let inputState = ctrl.changeState.getState(field.id);
    // convert GPS to vector
    const source = point_collection_cache_1.TopologicalPointCollectionCache.getCollectionLocation(field.collection.revision);
    const distanceBearingPitch = field.distanceBearingPitch(source);
    if (!inputState) {
        const { value } = field;
        inputState = new anchor_input_state_1.AnchorInputState(field);
        inputState.onValue(() => {
            field.Mutator.manual(inputState.value);
            // This will ensure topo map is updated (if it exists) and a user is updating vector locations
            point_collection_cache_1.TopologicalPointCollectionCache.dropCollectionVectors(field.collection.revision);
        });
        ctrl.changeState.addState(field.id, inputState);
        if (value != null) {
            inputState.setValue({
                distance: distanceBearingPitch.distance,
                bearing: distanceBearingPitch.bearing,
                pitch: distanceBearingPitch.pitch,
                placement: value.placement,
                relatedSpanIds: value.relatedSpanIds,
                collectionTool: 'VECTOR',
            });
        }
    }
    const linkableSpanFields = [];
    field.collection.forEachField((x) => {
        if (core_shared_1.CollectionModelFieldVector.isVectorField(x)) {
            linkableSpanFields.push(x);
        }
    });
    if (!(0, lodash_1.isEqual)(linkableSpanFields.sort((a, b) => a - b), inputState.cachedSpanFields)) {
        inputState.populateRelatedSpansOptions(linkableSpanFields);
    }
    // If none of the inputs are focused, and the field model value changes
    // the input state should also update.
    if (distanceBearingPitch !== null &&
        !(inputState.distance.meters.focused ||
            inputState.distance.inch.focused ||
            inputState.distance.feet.focused ||
            inputState.bearing.focused)) {
        inputState.setValue(Object.assign(Object.assign({}, distanceBearingPitch), { placement: inputState.placement.value, relatedSpanIds: inputState.relatedSpans.map((x) => x.value), collectionTool: 'VECTOR' }));
    }
    return anchor_input_1.AnchorInput.view(inputState, ctrl, field);
}
exports.AnchorManualFieldView = {
    hasClear() {
        return false;
    },
    viewInline(field) {
        if (!field.hasValue()) {
            return null;
        }
        // convert location to distance/bearing
        const source = point_collection_cache_1.TopologicalPointCollectionCache.getCollectionLocation(field.collection.revision);
        const distanceBearingPitch = field.distanceBearingPitch(source);
        return `${field_info_1.FieldInfo.viewVectorInline(distanceBearingPitch)}, Alignment: ${(0, i18n_1.Translate)(field.value.placement)}`;
    },
    hasDetail() {
        return false;
    },
    viewDetail() {
        return null;
    },
    viewEdit(field, ctrl) {
        return viewAnchorManualEdit(field, ctrl);
    },
};
exports.AnchorP2PFieldView = {
    viewInline(field) {
        // convert location to distance/bearing
        const source = point_collection_cache_1.TopologicalPointCollectionCache.getCollectionLocation(field.collection.revision);
        const distanceBearingPitch = field.distanceBearingPitch(source);
        return `${field_info_1.FieldInfo.viewVectorInline(distanceBearingPitch)}, Alignment: ${(0, i18n_1.Translate)(field.value.placement)}`;
    },
    hasDetail() {
        return true;
    },
    viewDetail(field) {
        const collection = field.collection;
        const captures = field.getCaptures();
        const p2pMeasurement = core_shared_1.MultiPoint.Points(captures);
        const stats = [
            { name: i18n_1.T.DISTANCE_VERTICAL, value: Math.abs(p2pMeasurement.vertical) },
            { name: i18n_1.T.DISTANCE_HORIZONTAL, value: p2pMeasurement.horizontal },
        ];
        return field_info_1.FieldInfo.viewCaptures(collection, captures, stats);
    },
    viewEdit(field, ctrl) {
        return viewAnchorManualEdit(field, ctrl);
    },
};
//# sourceMappingURL=anchor.field.view.js.map